import { Button, THEME } from "@myloc/myloc-gui";
import { useEffect, useState } from "react";
import { useTranslate } from "../../../../../language/i18n";
import registerActionService from "../../../../../services/registerAction/registerActionService";
import RegisterActionModal from "./RegisterActionModal";
import { OrderDefinition, Product } from "../../../../../services/registerAction/types";

interface RegisterActionButtonProps {
  inventoryId: string;
  product: Product;
  onActionRegistered?: () => void;
}

const RegisterActionButton = ({ inventoryId, product, onActionRegistered }: RegisterActionButtonProps) => {
  const translate = useTranslate();
  const [orderDefinitions, setOrderDefinitions] = useState<OrderDefinition[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalKey, setModalKey] = useState(0);

  useEffect(() => {
    const fetchDefinitions = async () => {
      setIsLoading(true);

      try {
        const response = await registerActionService.getLogisticsOrderDefinitions(inventoryId);

        if (response.data) {
          setOrderDefinitions(Array.isArray(response.data) ? response.data : []);
        }
      } finally {
        setIsLoading(false);
      }
    };

    if (inventoryId) fetchDefinitions();
  }, [inventoryId]);

  const handleOpen = () => {
    setModalKey(prev => prev + 1);
    setModalVisible(true);
  };

  const handleClose = () => {
    setModalVisible(false);
  };

  return (
    <>
      <Button
        theme={THEME.SECONDARY}
        customCssClass=""
        onClick={handleOpen}
        disabled={orderDefinitions.length === 0}
        isLoading={isLoading}
      >
        {translate("REGISTER_ACTION")}
      </Button>
      <RegisterActionModal
        key={modalKey}
        visible={modalVisible}
        onClose={handleClose}
        inventoryId={inventoryId}
        product={product}
        orderDefinitions={orderDefinitions}
        onActionRegistered={onActionRegistered}
      />
    </>
  );
};

export default RegisterActionButton;
